/*
  File name: main.js
    Program Description:
    - This file initializes all files to the root component of the system
    - Most of the directories initialized in the src file are included to inform
    Vue that these files are needed and be mounted in the main app file.
*/

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import session from './plugins/session'
import store from './store'
import meta from './meta'
import users from '@/utils/webapi/users'
import VueSanitize from 'vue-sanitize-directive'

Vue.use(VueSanitize)
Vue.config.productionTip = false
Vue.prototype.$metaData = meta
Vue.prototype.$users = users

new Vue({
  router,
  vuetify,
  store,
  session,
  render: (h) => h(App)
}).$mount('#app')
